import { create } from "zustand";
import createUserSlice, { UserSlice } from "./userSlice";
import createGeneralSettingsSlice, { GeneralSettingsSlice } from "./generalSettingsSlice";

import createNavigationSlice, { NavigationSlice } from "./navigationSlice";
import createMiscellaneousSlice, { MiscellaneousSlice } from "./miscellaneousSlice";
import createSelectedSlice, { SelectedSlice } from "./selectedSlice";
import createAppDataSlice, { AppDataSlice } from "./appDataSlice";
import createNotificationSlice, { NotificationSlice } from "./notificationSlice";

export type BoundStore = AppDataSlice &
  GeneralSettingsSlice &
  MiscellaneousSlice &
  NavigationSlice &
  NotificationSlice &
  SelectedSlice &
  UserSlice;

const useBoundStore = create<BoundStore>((...a) => ({
  ...createAppDataSlice(...a),
  ...createGeneralSettingsSlice(...a),
  ...createMiscellaneousSlice(...a),
  ...createNavigationSlice(...a),
  ...createNotificationSlice(...a),
  ...createSelectedSlice(...a),
  ...createUserSlice(...a),
}));

export const initialStore = useBoundStore.getState();

export default useBoundStore;
